import type { Metadata } from "next";

export type WeeklyHours = {
  label: string;
  value: string;
  days: string[];
  isClosed?: boolean;
};

export const siteConfig = {
  name: "Unchai Thai Restaurant",
  description:
    "Unchai Thai Restaurant serves comforting Thai noodle soups, curries, stir-fries, and desserts on Burrard Street in Vancouver.",
  canonicalBaseUrl: "https://unchai.benning.cloud",
  priceRange: "$$",
  cuisine: ["Thai"],
  address: {
    line1: "2351 Burrard Street",
    line2: "Vancouver, BC V6J 3J2",
    city: "Vancouver",
    region: "BC",
    postalCode: "V6J 3J2",
    country: "CA",
    mapLink: "https://maps.google.com/?q=Unchai+Thai+Restaurant+2351+Burrard+Street+Vancouver",
  },
  contact: {
    phoneDisplay: "(604) 559 6484",
    phoneHref: "tel:+16045596484",
    email: "unchairestaurant@gmail.com",
  },
  hours: {
    openTime: "11:30",
    closeTime: "22:00",
    kitchenCloseTime: "21:00",
    display: "See daily hours",
    weeklyHours: [
      { label: "Monday", value: "Closed", days: ["Monday"], isClosed: true },
      {
        label: "Tuesday – Thursday",
        value: "11:30 AM – 3:00 PM, 4:00 PM – 9:00 PM",
        days: ["Tuesday", "Wednesday", "Thursday"],
      },
      {
        label: "Friday – Sunday",
        value: "11:30 AM – 10:00 PM",
        days: ["Friday", "Saturday", "Sunday"],
      },
    ] as WeeklyHours[],
  },
  socials: {
    yelp: "https://www.yelp.ca/biz/unchai-restaurant-vancouver",
    instagram: "https://www.instagram.com/unchai.restaurant",
    facebook: "https://www.facebook.com/unchai.restaurant",
  },
};

export const getCanonicalUrl = (path = "/") =>
  `${siteConfig.canonicalBaseUrl}${path === "/" ? "" : path}`;

export const defaultMetadata: Metadata = {
  metadataBase: new URL(siteConfig.canonicalBaseUrl),
  title: "Unchai Thai Restaurant | Vancouver",
  description: siteConfig.description,
  alternates: {
    canonical: siteConfig.canonicalBaseUrl,
  },
  openGraph: {
    title: "Unchai Thai Restaurant | Vancouver",
    description: siteConfig.description,
    type: "website",
    locale: "en_US",
    url: siteConfig.canonicalBaseUrl,
    siteName: siteConfig.name,
  },
  twitter: {
    card: "summary_large_image",
    title: "Unchai Thai Restaurant | Vancouver",
    description: siteConfig.description,
  },
  robots: {
    index: true,
    follow: true,
  },
};

export const formatTimeToDisplay = (time: string) => {
  const [hours, minutes] = time.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const normalizedHour = hours % 12 || 12;

  return `${normalizedHour}:${minutes.toString().padStart(2, "0")} ${period}`;
};

export const openingHoursSpecification = siteConfig.hours.weeklyHours
  .filter((hours) => !hours.isClosed)
  .map((hours) => ({
    "@type": "OpeningHoursSpecification",
    dayOfWeek: hours.days,
    opens: siteConfig.hours.openTime,
    closes: siteConfig.hours.closeTime,
  }));
